import { tidyPhoneNumber } from '../utils/inputValidation';

// Mobile number as two plain inputs in one box: country code | number.
// Keeping the code in its own input means typing the number can never overwrite it,
// and screen readers announce the two parts separately.
const digitsOnly = (value) => value.replace(/\D/g, '');

const PhoneField = ({ countryCode, number, onCountryCodeChange, onNumberChange }) => (
  <div className="form-group">
    <label htmlFor="phone">Mobile Number <span aria-label="required">*</span></label>
    <div className="phone-split">
      <div className="phone-code">
        <span aria-hidden="true">+</span>
        <input
          type="tel" id="countryCode" name="countryCode"
          value={countryCode}
          onChange={(e) => onCountryCodeChange(digitsOnly(e.target.value).slice(0, 3))}
          required aria-required="true" aria-label="Country code"
          inputMode="numeric" autoComplete="tel-country-code"
        />
      </div>
      <input
        type="tel" id="phone" name="phoneNumber"
        className="phone-number"
        value={number}
        onChange={(e) => onNumberChange(tidyPhoneNumber(e.target.value, countryCode))}
        required aria-required="true" aria-describedby="phone-hint"
        inputMode="numeric" autoComplete="tel-national"
      />
    </div>
    <p id="phone-hint" className="field-hint">
      The country code is 91 for India. Change it only if your number is from another country.
    </p>
  </div>
);

export default PhoneField;
